import type {
  MeetingTeacherGroups,
  MeetingTeacherGroupsDto,
  MeetingTeacherRow,
  MeetingTeacherRowDto,
  MeetingTeacherRowIdentityDto,
} from "meetings/shared/types";

const teacherRowFromDto = (dto: MeetingTeacherRowDto): MeetingTeacherRow => ({
  teacherShortage: dto.teacher_shortage,
  lessonClass: dto.lesson_class,
  subjectShortage: dto.subject_shortage,
  teacherShortageNew: dto.teacher_shortage_new,
  teacherShortageExtra: dto.teacher_shortage_extra,
});

export const teacherGroupsFromDto = (
  dto: MeetingTeacherGroupsDto,
): MeetingTeacherGroups =>
  Object.fromEntries(
    Object.entries(dto).map(([groupKey, rows]) => [
      groupKey,
      rows.map(teacherRowFromDto),
    ]),
  );

/** Endpoint contract: the row goes back with the changed values filled in. */
export const teacherRowToDto = (
  row: MeetingTeacherRow,
): MeetingTeacherRowDto => ({
  teacher_shortage: row.teacherShortage,
  lesson_class: row.lessonClass,
  subject_shortage: row.subjectShortage,
  lesson_class_new: row.lessonClass,
  subject_shortage_new: row.subjectShortage,
  teacher_shortage_new: row.teacherShortageNew,
  teacher_shortage_extra: row.teacherShortageExtra,
});

/** The remove endpoint takes the row's identity, not its changed values. */
export const teacherRowIdentityToDto = (
  row: MeetingTeacherRow,
): MeetingTeacherRowIdentityDto => ({
  teacher_shortage: row.teacherShortage,
  lesson_class: row.lessonClass,
  subject_shortage: row.subjectShortage,
});
